import { useEffect, useState } from 'react';

const DIRECTION_THRESHOLD = 12;

export default function useScrollHeader({ enabled, pinned, headerRef, resetKey }) {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    setHidden(false);
    if (!enabled || pinned) return undefined;

    // Clamp rubber-band scrolling on phones so bouncing at either end does
    // not count as an intentional change of direction.
    const scrollPosition = () => Math.max(0, Math.min(
      window.scrollY,
      Math.max(0, document.documentElement.scrollHeight - window.innerHeight),
    ));
    let previousY = scrollPosition();
    let anchorY = previousY;
    let direction = 0;

    const handleScroll = () => {
      const currentY = scrollPosition();
      const delta = currentY - previousY;
      const headerHeight = headerRef.current?.offsetHeight || 72;

      if (currentY <= headerHeight) {
        setHidden(false);
        anchorY = currentY;
        direction = 0;
      } else if (delta !== 0) {
        const nextDirection = Math.sign(delta);
        if (nextDirection !== direction) {
          anchorY = previousY;
          direction = nextDirection;
        }
        if (Math.abs(currentY - anchorY) >= DIRECTION_THRESHOLD) {
          setHidden(direction > 0);
          anchorY = currentY;
        }
      }

      previousY = currentY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [enabled, pinned, headerRef, resetKey]);

  return enabled && !pinned && hidden;
}
